'use client'

import Script from "next/script";

function ConcordConsentScripts() {
  return (
      <Script
        id="concord-consent"
        src="https://api.concord.tech/site-v1/971c84d1-5935-449e-bdda-cc3ab1178074/site-client"
        strategy="beforeInteractive"
      />
  );
}

export default ConcordConsentScripts;

// Cyware Staging Site ID: c072e794-b21d-42eb-b620-04c853b08bbb
// Cyware Production Site ID: 971c84d1-5935-449e-bdda-cc3ab1178074